import { getAdmin, postAdminForm } from "../axios/api/AdminBaseUrl";
import { buildQueryString } from "../utils/queryParams";
export const resident ={
  excel:{
    key: "excel",
    call:(block_id,payload)=>{ return postAdminForm(`/admin/unit_excel_upload/${block_id}/`,payload);
  }
  },
 list:{
  key:"list",
  call: (blockId, page, search, statusFilter, ordering) => {
    const query = buildQueryString({ page, search, status: statusFilter, ordering })
    return getAdmin(`/admin/unit/?building_id=${blockId}&${query}`)
  }
},

}